<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pi_inoutno,pi_whname,pi_remark"
      placeholder="输入单据编号、仓库、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/stock/goodsback/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pi_inoutno}}</p>
          <p>{{ item.pi_buyername }}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.pi_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.pi_costtotal}}</p>
          <p>{{ item.pi_departmentname }}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pi_status!='已审核'}"
          >{{item.pi_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('pi_costtotal')}}</em>
    </div>
    
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";

import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
   
  },
  mixins: [list],
  data() {
    return {
      params: {
        caller: 'GoodsBack'
      },
      listUrl: "/api/storage/prodinout/list",
      filters: [
        {
          type: "date",
          name: "pi_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "pi_class='MOVEOUT' and pi_otherkind='还货单'"
            },
            {
              value: 1,
              label: "待审核",
              condition: "pi_class = 'MOVEOUT' and pi_otherkind='还货单' and pi_statuscode<>'AUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "pi_class = 'MOVEOUT' and pi_otherkind='还货单' and pi_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>